import * as React from 'react';
import { observer } from 'mobx-react';
import { Notice, Separator } from '@teliaee/design-system';
import useStores from '../stores/UseStores';
import { useIsMobileHook } from '../util/hooks/useIsMobile';

const NoticeAuthUpgrade = (): React.JSX.Element | null => {
  const {
    translateStore: { translate },
    homeStore: { homeResponse },
  } = useStores();
  const { isMobile } = useIsMobileHook();

  const shouldShowNotice = isMobile && homeResponse.params?.upgradeAuth;

  if (!shouldShowNotice) {
    return null;
  }

  return (
    <>
      <Notice>{translate('auth.level.upgradeNeeded')}</Notice>
      <Separator spacing="small" color="invisible" />
    </>
  );
};

export default observer(NoticeAuthUpgrade);
